import { useDialog } from '@/ui-plus/dialog/use-dialog';
import { authState } from '@/ui-plus/useAuth';
import ClaimEmailForm from '@auth-frontend-vue/components/forms/ClaimEmailForm.vue';
import { startRefreshingTokens } from '@api-client/auth/auth';
import { isPlaceholderEmail } from '@lib/utils/phoneToPlaceholderEmail';

const dialog = useDialog();

/** Soft: dismissible. Hard checkout uses iframe dialog instead. */
export function showClaimEmailForm(options?: { closeable?: boolean }) {
    const closeable = options?.closeable ?? true;
    return new Promise<number>((resolve) => {
        dialog.show({
            title: 'Add your email',
            closeable,
            description: 'Enter your email and the 4-digit code we send. You only need to do this once.',
            component: ClaimEmailForm,
            props: {
                showCancel: closeable,
            },
            onSuccess: () => {
                resolve(1);
            },
            onError: () => {
                resolve(-1);
            },
            onCancel: () => {
                resolve(-1);
            }
        })
    })
}


/** Soft email prompt: only for placeholder (phone-only) emails. Cancel is ok; re-asks on next page load. */
export async function maybePromptClaimEmail() {
    const payload = authState.value.accessTokenPayload;
    if (payload && payload.email && !isPlaceholderEmail(payload.email)) return;
    await startRefreshingTokens();
    await new Promise(resolve => setTimeout(resolve, 100));
    const payloadNew = authState.value.accessTokenPayload;
    if (!payloadNew?.email || !isPlaceholderEmail(payloadNew.email)) return;
    await showClaimEmailForm({ closeable: true });
}

/** Hard: loop until placeholder email is replaced with a real one. */
// export async function ensureClaimEmail() {
//     await startRefreshingTokens();
//     while (
//         authState.value.accessTokenPayload?.email
//         && isPlaceholderEmail(authState.value.accessTokenPayload.email)
//     ) {
//         await showClaimEmailForm({ closeable: false });
//     }
// }
